import React from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import { Link, useHistory } from 'react-router-dom';

import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../util/routes';
import { Form, LocationAutocompleteInput } from '../../../components';

import styles from './SectionHero.module.css';
import bgBanner from "../../../assets/Porch 2.jpeg";

const identity = v => v;

const SectionHero = () => {
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();

  const handleSearchSubmit = values => {
    const { keywords, location } = values;
    const { search, selectedPlace } = location || {};
    const { origin, bounds } = selectedPlace || {};
    const searchParams = {
      ...(keywords ? { keywords } : {}),
      ...(selectedPlace ? { address: search, origin, bounds } : {}),
    };
    history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, searchParams));
  };

  return (
    <section
      className={styles.heroSection}
      style={{
        backgroundImage: `url(${bgBanner})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className={styles.heroContent}>
        <div className={styles.heroText}>
          <h1 className={styles.heroTitle}>America&apos;s Neighborhood Marketplace</h1>
          <p className={styles.heroSubtitle}>
            Buy Products and Book Services From Neighbors <br /> Near and Far
          </p>

          <div className={styles.ctaButtons}>
            <Link to="/s" className={`${styles.ctaButton} ${styles.primary}`}>
              Find Products
            </Link>
            <Link to="/s" className={`${styles.ctaButton} ${styles.secondary}`}>
              Find Services
            </Link>
          </div>

          <FinalForm
            onSubmit={handleSearchSubmit}
            render={formRenderProps => {
              const { handleSubmit } = formRenderProps;
              return (
                <Form className={styles.searchContainer} onSubmit={handleSubmit}>
                  <div className={styles.searchGroup}>
                    <Field
                      name="keywords"
                      render={({ input }) => (
                        <input
                          {...input}
                          type="text"
                          placeholder="What are you looking for?"
                          className={styles.searchInput}
                        />
                      )}
                    />
                  </div>

                  <div className={styles.searchGroup}>
                    <Field
                      name="location"
                      format={identity}
                      render={({ input, meta }) => {
                        const { onChange, ...restInput } = input;
                        const searchOnChange = value => {
                          onChange(value);
                        };
                        return (
                          <LocationAutocompleteInput
                            id="landing-location-search"
                            className={styles.locationRoot}
                            iconClassName={styles.locationIcon}
                            inputClassName={styles.locationInput}
                            predictionsClassName={styles.locationPredictions}
                            placeholder="Near City, State or Zip"
                            closeOnBlur={true}
                            input={{ ...restInput, onChange: searchOnChange }}
                            meta={meta}
                            useDarkText
                          />
                        );
                      }}
                    />
                    <button type="submit" className={styles.searchButton}>Search</button>
                  </div>
                </Form>
              );
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default SectionHero;
